var map = {
	"./bones.png": "7d88",
	"./character_banner.png": "f924",
	"./cleric.png": "5ad4",
	"./crusader.png": "ad00",
	"./mage.png": "c7b3",
	"./priestess.png": "bd95",
	"./rogue.png": "f8dc",
	"./thief.png": "e503",
	"./witch.png": "7914"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b222";